// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","577": "__federation_expose_useHostAuthState",}[chunkId] || chunkId) + "-" + {"122": "2c7bfc488a4c79ca","398": "186ff18b576d3ec7","545": "20e6b6213e4517de","577": "38ae27adb57ed741",}[chunkId] + ".bundle.js"
}